<template>
  <div class="group-roles">
    <GroupRolesPicker
      :group="group"
      :roles="roles ? roles: []"
      :groupRoles="groupRoles ? groupRoles: []"
      v-on:addRoleToGroup="addRoleToGroup"
      v-on:removeRoleFromGroup="removeRoleFromGroup"
    />
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import GroupRolesPicker from "@/components/Access/Groups/GroupRolesPicker";

export default {
  mixins: [mixin],
  props: {
    group: { type: Object, required: true }
  },
  components: {
    GroupRolesPicker
  },
  data() {
    return {
      groupRoles: [],
      roles: [],
      snackbar: false,
      errorMessage: "",
      groupUuid: null
    };
  },
  computed: {
    ...mapState({
      currentOrganization: state => state.organizations.current,
      availableRolesError: state =>
        state.organizations.fetchAvailableGroupRoles.error,
      availableRolesLoading: state =>
        state.organizations.fetchAvailableGroupRoles.pending,
      fetchOrganizationGroupRolesLoading: state =>
        state.organizations.fetchOrganizationGroupRoles.pending,
      fetchOrganizationGroupRolesError: state =>
        state.organizations.fetchOrganizationGroupRoles.error
    })
  },
  watch: {
    group() {
      if (this.group.uuid) {
        this.groupUuid = this.group.uuid;
        this.refresh();
      }
    }
  },
  methods: {
    ...mapActions("organizations", {
      fetchAvailableGroupRoles: "fetchAvailableGroupRoles",
      fetchOrganizationGroupRoles: "fetchOrganizationGroupRoles",
      addOrganizationGroupRole: "addOrganizationGroupRole",
      removeOrganizationGroupRole: "removeOrganizationGroupRole"
    }),
    refresh() {
      this.fetchOrganizationGroupRoles({
        organizationUuid: this.currentOrganization.uuid,
        groupUuid: this.groupUuid
      })
        .then(roles => {
          this.groupRoles = roles;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
      this.fetchAvailableGroupRoles({
        organizationUuid: this.currentOrganization.uuid,
        groupUuid: this.groupUuid
      })
        .then(roles => {
          this.roles = roles;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    addRoleToGroup(roleUuid, roleName) {
      this.addOrganizationGroupRole({
        organizationUuid: this.currentOrganization.uuid,
        groupUuid: this.groupUuid,
        roleUuid: roleUuid,
        roleName: roleName
      })
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    removeRoleFromGroup(roleUuid, roleName) {
      this.removeOrganizationGroupRole({
        organizationUuid: this.currentOrganization.uuid,
        groupUuid: this.groupUuid,
        roleUuid: roleUuid,
        roleName: roleName
      })
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    if (this.group.uuid) {
      this.groupUuid = this.group.uuid;
      this.refresh();
    }
  }
};
</script>

<style>
</style>